<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <div>
        <!-- 受信リスト(スマホ以外) -->
        <v-simple-table fixed-header dense v-if="notificationType=='receive' && notifications != null && !$vuetify.breakpoint.xs">
            <thead>
                <tr>
                    <th class="text-center"></th>
                    <th class="text-left" width="200">差出人</th>
                    <th class="text-left" style="width:100%">件名</th>
                    <th></th>
                    <th class="text-left">日時</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="notification in notifications.list" :key="notification.body.dateTime" @click="onClickNotification(notification)" :class="rowFontWeight(notification)">
                    <td class="text-center pl-1 pr-1">
                        <v-checkbox @click.native.stop="onClickCheckReceiveNotification(notification)"></v-checkbox>
                    </td>
                    <td class="text-left pa-0" style="white-space:nowrap">
                        <v-avatar class="ma-0" size="30" rounded>
                            <v-img v-if="notification.body.sender == null" src="@/assets/icon-72x72.png"/>
                            <v-img v-else-if="notification.sender.avaterURL == null" src="@/assets/no_avater_image.png"/>
                            <v-img v-else-if="notification.sender.avaterURL != null" :src="notification.sender.avaterURL"/>
                        </v-avatar>
                        <span v-if="notification.body.sender != null">{{notification.sender.userName}}</span>
                        <span v-else>【圃場管理システム】</span>
                    </td>
                    <td>
                        <v-icon>{{icon(notification.body)}}</v-icon> {{notification.body.content.title}}
                    </td>
                    <td class="text-center pl-1 pr-1">
                        <v-icon v-if="notification.body.attachedFiles != null && notification.body.attachedFiles.length > 0">mdi-attachment</v-icon>
                    </td>
                    <td>
                        <span class="caption">{{notification.body.dateTime}}</span>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>
        <!-- 受信リスト(スマホ) -->
        <v-simple-table fixed-header dense v-if="notificationType=='receive' && notifications != null && $vuetify.breakpoint.xs">
            <tbody>
                <tr v-for="notification in notifications.list" :key="notification.body.dateTime">
                    <td class="text-center pa-0">
                        <v-checkbox @click.native.stop="onClickCheckReceiveNotification(notification)"></v-checkbox>
                    </td>
                    <td class="pa-0">
                        <v-card flat class="mt-2 mb-1" @click="onClickNotification(notification)">
                            <div class="d-flex flex-no-wrap justify-space-left">
                                <div>
                                    <v-avatar class="ma-0" size="48" rounded>
                                        <v-img v-if="notification.body.sender == null" src="@/assets/icon-72x72.png"/>
                                        <v-img v-else-if="notification.sender.avaterURL == null" src="@/assets/no_avater_image.png"/>
                                        <v-img v-else-if="notification.sender.avaterURL != null" :src="notification.sender.avaterURL"/>
                                    </v-avatar>
                                </div>
                                <div style="width:100%; white-space:nowrap" :class="'ml-1 '+rowFontWeight(notification)">
                                    <v-icon>{{icon(notification.body)}}</v-icon>{{notification.body.content.title}}<br/>
                                    <span v-if="notification.body.sender != null" style="font-size:x-small">{{notification.sender.userName}}</span>
                                    <span v-else style="font-size:x-small">【圃場管理システム】</span>
                                </div>
                            </div>
                            <span style="font-size:xx-small">{{notification.body.dateTime}}</span><br/>
                        </v-card>
                    </td>
                </tr>
            </tbody>        
        </v-simple-table>
        <!-- 送信リスト -->
        <v-simple-table fixed-header dense v-if="notificationType=='send' && notifications != null && !$vuetify.breakpoint.xs">
            <thead>
                <tr>
                    <th class="text-center" width="50"></th>
                    <th class="text-left" width="200">宛先</th>
                    <th class="text-left" style="width:100%">件名</th>
                    <th class="text-left">日時</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="notification in notifications.list" :key="notification.body.notification.dateTime" @click="onClickNotification(notification)">
                    <td class="text-center pl-1 pr-1">
                        <v-checkbox @click.native.stop="onClickCheckSendNotification(notification)"></v-checkbox>
                    </td>
                    <td class="text-left pa-0" style="white-space:nowrap">
                        <template v-if="notification.body.type != 'group_member' && notification.body.type != 'belong_group_member' && notification.body.type != 'reply' && notification.body.type != 'custom' && notification.body.type != 'user'">
                            <v-icon>mdi-share-variant</v-icon>
                            <span>
                                <span v-if="notification.receivers.length >= 1">{{notification.receivers[0].groupName}}</span>
                                <span v-if="notification.receivers.length > 1">他</span>
                            </span>
                        </template>
                        <template v-else-if="notification.body.type == 'custom'">
                            <template v-if="notification.receivers.length > 0">
                                <v-avatar class="ma-0" size="30" rounded>
                                    <v-img v-if="notification.receivers[0].users[0].avaterURL == null" src="@/assets/no_avater_image.png"/>
                                    <v-img v-if="notification.receivers[0].users[0].avaterURL != null" :src="notification.receivers[0].users[0].avaterURL"/>
                                </v-avatar>
                                {{notification.receivers[0].users[0].userName}}
                                <span v-if="notification.receivers.length > 1 || notification.receivers[0].users.length > 1">他</span>
                            </template>
                            <template v-else>
                                unknown
                            </template>
                        </template>
                        <template v-else>
                            <span>
                                <template v-if="notification.receivers.length > 0">
                                    <v-avatar class="ma-0" size="30" rounded>
                                        <v-img v-if="notification.receivers[0].avaterURL == null" src="@/assets/no_avater_image.png"/>
                                        <v-img v-if="notification.receivers[0].avaterURL != null" :src="notification.receivers[0].avaterURL"/>
                                    </v-avatar>
                                    {{notification.receivers[0].userName}}
                                    <span v-if="notification.receivers.length > 1">他</span>
                                </template>
                                <template v-else>
                                    unknown
                                </template>
                            </span>
                        </template>
                    </td>
                    <td> 
                        <v-icon>{{icon(notification.body.notification)}}</v-icon> {{notification.body.notification.content.title}}
                    </td>
                    <td>
                        <span class="caption">{{notification.body.notification.dateTime}}</span>
                    </td>
                </tr>
            </tbody>        
        </v-simple-table>
        <!-- 送信リスト(スマホ) -->
        <v-simple-table fixed-header dense v-if="notificationType=='send' && notifications != null && $vuetify.breakpoint.xs">
            <tbody>
                <tr v-for="notification in notifications.list" :key="notification.body.notification.dateTime" >
                    <td class="text-center pr-0 pl-0">
                        <v-checkbox @click.native.stop="onClickCheckSendNotification(notification)"></v-checkbox>
                    </td>
                    <td style="width:100%" class="pa-0">
                        <v-card flat class="mt-2 mb-1" @click="onClickNotification(notification)" color="transparent">
                            <div style="white-space:nowrap">
                                <v-icon>{{icon(notification.body.notification)}}</v-icon>
                                <span>{{notification.body.notification.content.title}}</span>
                            </div>
                            <template v-if="notification.body.type != 'group_member' && notification.body.type != 'belong_group_member' && notification.body.type != 'reply'">
                                <v-icon>mdi-share-variant</v-icon>
                                <span>
                                    <span v-if="notification.receivers.length >= 1">{{notification.receivers[0].groupName}}</span>
                                    <span v-if="notification.receivers.length > 1">他</span>
                                </span>
                            </template>
                            <template v-else>
                                <span>
                                    <template v-if="notification.receivers.length > 0">
                                        <v-avatar class="ma-0" size="30" rounded>
                                            <v-img v-if="notification.receivers[0].avaterURL == null" src="@/assets/no_avater_image.png"/>
                                            <v-img v-if="notification.receivers[0].avaterURL != null" :src="notification.receivers[0].avaterURL"/>
                                        </v-avatar>
                                        {{notification.receivers[0].userName}}
                                        <span v-if="notification.receivers.length > 1">他</span>
                                    </template>
                                    <template v-else>
                                        unknown
                                    </template>
                                </span>
                            </template>
                            <br/>
                            <span style="font-size:xx-small">{{notification.body.notification.dateTime}}</span><br/>
                        </v-card>
                    </td>
                </tr>
            </tbody>        
        </v-simple-table>
        <v-btn v-if="!notifications.allReaded" @click="onClickShowMore" x-small color="primary">show more</v-btn>
        <span v-if="notificationType=='receive' && notifications.list.length == 0" class="caption">受信通知はありません</span>
        <span v-if="notificationType=='send' && notifications.list.length == 0" class="caption">送信通知はありません</span>
        <div class="mt-2 mb-2" />
        <v-slide-x-transition>
            <v-btn v-if="checkedNotifications.length > 0" color="warning" dark @click="onClickDelete" class="mr-2"><v-icon>mdi-delete</v-icon>削除</v-btn>
        </v-slide-x-transition>
    </div>
</template>

<script>
    export default {
        props: {
            notificationType: {
                type: String,
                default: ""
            },
            notifications: {
                type: Object,
                default: null
            }
        },
        data: function () {
            return {
                checkedNotifications: []
            }
        },
        methods: {
            /**
             * 指定された通知から行のフォントのスタイルを返す
             */
            rowFontWeight: function (notification) {
                if (notification.body.openedDateTime == '') {
                    return "font-weight-bold font-italic"
                } else {
                    return "font-weight-regular"
                }
            },
            /**
             * 指定された通知から件名に表示するアイコンを返す
             */
            icon: function (notification) {
                switch (notification.content.type) {
                    case 1:
                        return "mdi-information"
                    case 10:
                    case 11:
                    case 12:
                        return "mdi-share-variant"
                    case 13:
                        switch (notification.data.type) {
                            case 0:
                                return "mdi-information"
                            case 1:
                                return "mdi-alert"
                        }
                        break
                    case 20:
                        return "mdi-comment-account"
                    case 30:
                        return "mdi-file-document-edit-outline"
                    case 90:
                        return "mdi-message-alert"
                }
            },
            onClickShowMore: function () {
                // this.$emit('onMore')
                switch (this.notificationType) {
                    case "receive":
                        this.$store.commit("managementItems/addNextReceivedNotifications")
                        break;
                    case "send":
                        this.$store.commit("managementItems/addNextSentNotifications")
                        break;
                }
            },
            onClickCheckReceiveNotification: function (notification) {                
                const index = this.checkedNotifications.findIndex((v) => v.body.notificationID === notification.body.notificationID)
                if (index>=0) {
                    this.checkedNotifications.splice(index, 1)
                } else {
                    this.checkedNotifications.push(notification)
                }
            },
            onClickCheckSendNotification: function (notification) {                
                const index = this.checkedNotifications.findIndex((v) => v.body.notification.notificationID === notification.body.notification.notificationID)
                if (index>=0) {
                    this.checkedNotifications.splice(index, 1)
                } else {
                    this.checkedNotifications.push(notification)
                }
            },
            onClickNotification: function (notification) {
                this.$emit("onSelectedNotification", notification)
            },
            onClickDelete: function () {
                this.$emit("onSelectedDeleteNotifications", this.checkedNotifications)
            }
        }
    }
</script>
